// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consent-page {
    /* height: 100vh;
      width: 100vw; */
    /* background: #9eaaec; */
    /* background-color: #F2F3F9; */
    
    overflow-y: scroll;
  }
  
  .consent-header {
    display: flex;
    align-items: center;
    background-color: var(--neutral-white);
    width: 100%;
    padding: 16px 20px;
    gap: 12px;
    color: var(--black);
    font-size: 20px;
    font-weight: 600;
  }
  
  .contnet-container-wrapper {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 6px;
    border-radius: 16px;
    border: 0.5px solid var(--border-light);
    background-color: var(--neutral-white);
    box-shadow: 0px 2px 52px 0px rgba(0, 0, 0, 0.02);
  }
  
  .image-div {
    width: 226px;
    height: 107px;
    /* border-radius: 8px; */
    background-color: var(--light-neutral-2);
  }
  
  .consent-content-header {
    color: var(--almost-black);
    font-family: "Noto Sans";
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.193px;
    font-feature-settings: "clig" off, "liga" off;
    line-height: 150%;
    margin-top: 16px;
  }
  
  .consent-content-subheader {
    color: var(--dark-neutral-2);
    font-size: 15px;
    font-weight: 400;
    line-height: 205%;
    letter-spacing: 0.193px;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Noto Sans";
  }
  
  .consent-content-grid-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px 20px;
  }
  
  .divider {
    border-top: 0.5px solid var(--border-top-light);
    width: 100%;
  }
  
  .consent-content-bottom {
    border-radius: 12px;
    background: var(--light-neutral-2);
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 28px;
  }
  
  .consent-data-ques {
    color: var(--black);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.15px;
    text-transform: capitalize;
    font-family: "Noto Sans";
    font-feature-settings: "clig" off, "liga" off;
  }
  
  .consent-data-text {
    color: var(--dark-neutral-2);
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Noto Sans";
    font-size: 14px;
    font-weight: 400;
  }
  
  .consesnt-input-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .consent-input-wrapper {
    padding: 16px;
    background-color: var(--neutral-white);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }
  
  .consent-given {
    border-radius: 16px 16px 0px 0px;
    background-color: var(--green-3);
    border: 1px solid var(--green-2);
  }
  
  .custom-checkbox {
    width: 50px;
    height: 20px;
    accent-color: var(--green-1) !important;
  }
  
  .consent-input-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 145%;
    color: var(--almost-black);
  }
  
  .consent-proceed-btn {
    width: 100%;
    border-radius: 8px;
    border: 0.843px solid var(--light-neutral-4);
    background-color: var(--primary-dark);
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    color: var(--neutral-white);
    font-size: 16px;
    font-weight: 400;
  }
  .form-header {
    background-color: var(--light-neutral-2);
    /* position: fixed; 
    top: 0;
    left: 0;
    right: 0;
    background-color: #F2F3F9;
    z-index: 10000; Ensure it appears above other content */
    /* padding: 10px; Adjust padding as needed */
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); Optional: Add shadow for visual effect */
  }
  
`, "",{"version":3,"sources":["webpack://./src/Core/Components/Auth/RegisterComponent/RegisterComponent.css"],"names":[],"mappings":"AAAA;IACI;qBACiB;IACjB,yBAAyB;IACzB,+BAA+B;;IAE/B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,sCAAsC;IACtC,gDAAgD;EAClD;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,6CAA6C;IAC7C,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,6CAA6C;IAC7C,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,+CAA+C;IAC/C,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,4BAA4B;IAC5B,6CAA6C;IAC7C,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,4CAA4C;IAC5C,qCAAqC;IACrC,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,wCAAwC;IACxC;;;;;2DAKuD;IACvD,4CAA4C;IAC5C,qFAAqF;EACvF","sourcesContent":[".consent-page {\n    /* height: 100vh;\n      width: 100vw; */\n    /* background: #9eaaec; */\n    /* background-color: #F2F3F9; */\n    \n    overflow-y: scroll;\n  }\n  \n  .consent-header {\n    display: flex;\n    align-items: center;\n    background-color: var(--neutral-white);\n    width: 100%;\n    padding: 16px 20px;\n    gap: 12px;\n    color: var(--black);\n    font-size: 20px;\n    font-weight: 600;\n  }\n  \n  .contnet-container-wrapper {\n    padding: 24px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n  \n  .content-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px 6px;\n    border-radius: 16px;\n    border: 0.5px solid var(--border-light);\n    background-color: var(--neutral-white);\n    box-shadow: 0px 2px 52px 0px rgba(0, 0, 0, 0.02);\n  }\n  \n  .image-div {\n    width: 226px;\n    height: 107px;\n    /* border-radius: 8px; */\n    background-color: var(--light-neutral-2);\n  }\n  \n  .consent-content-header {\n    color: var(--almost-black);\n    font-family: \"Noto Sans\";\n    font-size: 20px;\n    font-weight: 700;\n    letter-spacing: 0.193px;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    line-height: 150%;\n    margin-top: 16px;\n  }\n  \n  .consent-content-subheader {\n    color: var(--dark-neutral-2);\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 205%;\n    letter-spacing: 0.193px;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    font-family: \"Noto Sans\";\n  }\n  \n  .consent-content-grid-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 16px 20px;\n  }\n  \n  .divider {\n    border-top: 0.5px solid var(--border-top-light);\n    width: 100%;\n  }\n  \n  .consent-content-bottom {\n    border-radius: 12px;\n    background: var(--light-neutral-2);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 20px 28px;\n  }\n  \n  .consent-data-ques {\n    color: var(--black);\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0.15px;\n    text-transform: capitalize;\n    font-family: \"Noto Sans\";\n    font-feature-settings: \"clig\" off, \"liga\" off;\n  }\n  \n  .consent-data-text {\n    color: var(--dark-neutral-2);\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    font-family: \"Noto Sans\";\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .consesnt-input-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .consent-input-wrapper {\n    padding: 16px;\n    background-color: var(--neutral-white);\n    border-radius: 16px;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n  }\n  \n  .consent-given {\n    border-radius: 16px 16px 0px 0px;\n    background-color: var(--green-3);\n    border: 1px solid var(--green-2);\n  }\n  \n  .custom-checkbox {\n    width: 50px;\n    height: 20px;\n    accent-color: var(--green-1) !important;\n  }\n  \n  .consent-input-text {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 145%;\n    color: var(--almost-black);\n  }\n  \n  .consent-proceed-btn {\n    width: 100%;\n    border-radius: 8px;\n    border: 0.843px solid var(--light-neutral-4);\n    background-color: var(--primary-dark);\n    display: flex;\n    gap: 8px;\n    padding: 12px 16px;\n    justify-content: center;\n    align-items: center;\n    color: var(--neutral-white);\n    font-size: 16px;\n    font-weight: 400;\n  }\n  .form-header {\n    background-color: var(--light-neutral-2);\n    /* position: fixed; \n    top: 0;\n    left: 0;\n    right: 0;\n    background-color: #F2F3F9;\n    z-index: 10000; Ensure it appears above other content */\n    /* padding: 10px; Adjust padding as needed */\n    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); Optional: Add shadow for visual effect */\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
